import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useRole } from './RoleContext';

const PermissionContext = React.createContext();

export const usePermissions = () => useContext(PermissionContext);

const PermissionProvider = ({ children }) => {
    const { role } = useRole();
    const [permissions, setPermissions] = useState([]);
    const [loading, setLoading] = useState(true); 

    useEffect(() => {
       
        if (!role) {
            setPermissions([]);
            setLoading(true); 
            return; 
        }

        const fetchPermissions = async () => {
            setLoading(true); 
            
            if (role === 'superadmin' || role === 'admin') {
                setPermissions([]);
                setLoading(false);
            } else {
                try {
                    const apiUrl = process.env.REACT_APP_API_URL;
                    const response = await axios.get(`${apiUrl}/api/roles/${role}/permissions`, { withCredentials: true });
                    setPermissions(response.data);
                } catch (error) {
                    console.error('Error fetching permissions for role:', role, error);
                    setPermissions([]); 
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchPermissions();

    }, [role]); 

    return (
        <PermissionContext.Provider value={{ permissions, loading }}>
            {children}
        </PermissionContext.Provider>
    );
};

export default PermissionProvider;